import React from 'react'
import { Subscriber } from 'react-broadcast'

const Feature = ({ render }) => (
  <Subscriber channel="feature">{render}</Subscriber>
)

export default Feature



// WEBPACK FOOTER //
// ./src/components/Feature/index.js